export default "__VITE_ASSET__CaapA7QB__"